import { classify } from '../helpers'
import { useHistory } from 'react-router-dom'
import { useEffect, useState } from 'react'

import Flex from '../components/utils/Flex'
import Stories from '../components/Stories'
import Container from '../components/utils/Container'
import UserbarUser from '../components/UserbarUser'


const Home = ({ children }) => {

	const history = useHistory()

	const [activeRoute, setActiveRoute] = useState('/home')
	const [tabs] = useState([
		{ name: 'My Feed', path: '/home' },
		{ name: 'Videos', path: '/home/videos' },
		{ name: 'Pictures', path: '/home/pictures' },
		{ name: 'Referrals', path: '/home/referrals' }
	])

	useEffect(() => {
		setActiveRoute(history.location.pathname)
	}, [history.location.pathname])

	return (
		<div className="home">
			<Container>
				<Flex on="lg" justify-between items-stretch className="pt-4 lg:pt-0">
					<Flex on="sm" items-center className="lg:py-4">
						<UserbarUser />
						<Flex
							items-end
							className="space-x-3 text-sm text-secondary sm:text-base font-light mt-3 sm:mt-0 sm:ml-8"
						>
							<p>0 Subs</p>
							<p>0 Following</p>
						</Flex>
					</Flex>
					<Flex
						items-center
						className="space-x-4 lg:space-x-8 text-sm md:text-base xl:text-xl font-bold text-primary"
					>
						{tabs.map(tab => (
							<Flex
								items-center
								key={tab.name}
								onClick={() => history.push(tab.path)}
								className={classify(
									"home__tab h-12 lg:h-full cursor-pointer", {
									active: activeRoute === tab.path
								})}
							>
								{tab.name}
							</Flex>
						))}
					</Flex>
				</Flex>
			</Container>
			<Stories />
			{children}
		</div>
	)
}

export default Home